import * as NetworkUtil from "./network";
import ColorUtil from "./ColorUtil";
import ArrayUtil from "./aArray";
import DateUtil from "./aDate";
import MathUtil from "./aMath";
import RouteUtil from "./route";
import OrgUtil from "./organize";
import ReportUtil from "./report";
import EmployeeUtil from "./employees";
import * as ActionUtil from "./actions";
import FirebaseUtil from "./firebase";
export function isFunction(...targets) {
	for (let i = 0; i < targets.length; i += 1) {
		if (targets[i] === undefined || targets[i] === null || typeof targets[i] !== "function") {
			return false;
		}
	}
	return true;
}

export function isAlive(...targets) {
	for (let i = 0; i < targets.length; i += 1) {
		if (targets[i] === undefined || targets[i] === null) {
			return false;
		}
	}
	return true;
}

export function isFillAlive(target){
	if(isAlive(target)){
		if((Array.isArray(target) && target.length === 0) ||
			(typeof target === "object" && Object.keys(target).length === 0)){
			return false;
		}
		return true;
	}
	return false;
}
/**
 * Extract value into new object.
 * @param {object} target 
 * @param {string[]} keys 
 */
export function extract(target, keys){
	const out = {};
	if(isAlive(target)){
		keys.forEach(k=>{ out[k] = target[k]; });
	}else{
		keys.forEach(k=>{ out[k]=undefined; });
	}
	return out;
}

export { 
	ColorUtil,
	NetworkUtil, ArrayUtil, DateUtil, 
	MathUtil, RouteUtil, OrgUtil,
	ReportUtil, EmployeeUtil,
	ActionUtil,
	FirebaseUtil
};


// WEBPACK FOOTER //
// ./src/util/index.js